import game from '../game/Game'
import { NEW_GAME, MOVE_ROBOT, LOAD_STATE, LOAD_GOAL } from '../actions/game'

export default function goals(state = {}, action) {
  switch (action.type) {
    case NEW_GAME:
      state.goal = action.goal
      state.color = action.goalColor
      return state
    case LOAD_STATE:
      return {
        goal: action.goal,
        color: action.goalColor
      }
    case LOAD_GOAL:
      return {
        goal: action.goal,
        color: action.goalColor
      }
    case MOVE_ROBOT:
      if(action.targetReached){
        return {
          goal: action.goal,
          color: action.goalColor
        }
      }
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/goals.js